/* eslint-disable react/forbid-prop-types */
import * as PropTypes from 'prop-types';
import { pointType } from './geometry';

export const textType = PropTypes.arrayOf(
  PropTypes.shape({
    shift: pointType.isRequired,
    size: pointType.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['sub', 'super']),
  }).isRequired
);

export const textGroupShape = {
  centerLabel: PropTypes.shape({
    parts: textType.isRequired,
  }),
  sideLabel: PropTypes.shape({
    parts: textType.isRequired,
    shift: pointType.isRequired,
  }),
  pos: pointType.isRequired,
  color: PropTypes.string.isRequired,
  center: PropTypes.object,
  side: PropTypes.object,
};

export const atomType = PropTypes.shape({
  ...textGroupShape,
  idx: PropTypes.string.isRequired,
  warnings: PropTypes.arrayOf(PropTypes.string.isRequired),
});

export const bondType = PropTypes.shape({
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  center: PropTypes.object,
  right: PropTypes.object,
  left: PropTypes.object,
  color: PropTypes.string,
});

export const bondLineShape = {
  pos1: pointType.isRequired,
  pos2: pointType.isRequired,
  bgColor: PropTypes.string.isRequired,
  bgOpacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string.isRequired,
};
